import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-modal-dismiss-button',
  templateUrl: './modal-dismiss-button.component.html',
  styleUrls: ['./modal-dismiss-button.component.scss'],
})
export class ModalDismissButtonComponent implements OnInit {

  constructor(
    private _modal: ModalController
  ) { }

  ngOnInit() {}

  dismiss() {
    this._modal.dismiss();
  }

}
